/*
 * @created : 2022/05/11
 * @author  : 伦宇
 * @desc    : 导航组件拆分导出
 */
import { Provider } from "mobx-react";
import { pcStores, mStores } from "../../../../lib";
import React from 'react';
import { DialogProps } from "@weapp/ui";
import { WxchatCom } from '../../../main/navigation/widgets/quickToolbar/WxchatCom';
import { AccountInfoProps } from "../accountInfo/types";
import { SearchProps } from "../widgets/QuickSearch/types";
import { AppDropMenusType } from "../appmenus/AppDropMenus";
import { isFirefox } from "../../../../utils";

const AccountInfo = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../accountInfo")
)

const AppDropMenus = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../appmenus/AppDropMenus")
)

const QuickSearch = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../widgets/QuickSearch")
)
const TenantDrop = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../widgets/Tenantdrop")
)
const FastCreateMenus = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../widgets/quickToolbar/FastCreateMenusTwo")
)

const CountTab = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../widgets/quickToolbar/CountTab")
)
const HelpDrop = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../widgets/helpDrop")
)
const MenuSettingDialog = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../../aside/menusSetting")
)
const QuickMenus = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../widgets/quickToolbar")
)
const TerminalDialog = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../../../../components/terminalDialog")
)
const Terminal = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../../../../components/main/terminal")
)
const InviteDialog = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../../../../components/inviteDialog")
)
//推荐拿福利弹窗
const InviteWelfareDialog = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../../../../components/main/InviteWelfare")
)
const TenantDialog = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../../../../components/main/createTeams/index")
)
const ClearCacheDialog = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../../../../components/clearCacheDialog")
)
const AppDisplaySetting = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../../../../components/main/defSetting")
)
const AppMainMenus = React.lazy(() => import(
    /* webpackChunkName: "layout_components" */
    "../appmenus/AppMainMenus")
)

export interface NavigationComProps {
    className?: string,
    [key: string]: any,
}

export type NavigationDialogProps = NavigationComProps & DialogProps;

export interface NavigationDropComProps {
    popupVisible?: boolean,
    handlePopupVisible?: any,
    isTilingPage?: boolean  //是否平铺显示
    popupClassName?: string,//弹层class
}

type NavigationDropProps = NavigationDropComProps & NavigationComProps;


function AccountInfoCom(props: NavigationComProps & AccountInfoProps) {//账户信息组件
    return (
        <Provider weId={`${props.weId || ''}_qpn2q5`}  {...pcStores}>
            <AccountInfo weId={`${props.weId || ''}_xaf29f`}  {...props} />
        </Provider>
    );
}
function AppDropMenusCom(props: NavigationDropProps & AppDropMenusType) {//更多应用下拉组件
    return (
        <Provider weId={`${props.weId || ''}_r8ss6b`}  {...pcStores}>
            <AppDropMenus weId={`${props.weId || ''}_qpqsq0`}   {...props} />
        </Provider>
    );
}
function QuickSearchCom(props: NavigationDropProps & SearchProps) {//全文检索组件
    return (
        <Provider weId={`${props.weId || ''}_qlo6ku`}   {...pcStores}>
            <QuickSearch weId={`${props.weId || ''}_lfj1fa`}    {...props} />
        </Provider>
    );
}
function TenantDropCom(props: NavigationDropProps) {//账户人员下拉组件
    const allProps = { ...props, popupVisible: true }
    return (
        <Provider weId={`${props.weId || ''}_8ul0oe`}    {...pcStores}>
            <TenantDrop weId={`${props.weId || ''}_emkn3v`}      {...allProps} />
        </Provider>
    );
}
function QuickMenusCom(props: NavigationDropProps) {//导航右侧快捷菜单组件
    const allProps = { ...props, source: 'external' }
    return (
        <Provider weId={`${props.weId || ''}_kh09tw`}    {...pcStores}>
            <QuickMenus weId={`${props.weId || ''}_c3ogp9`}      {...allProps} />
        </Provider>
    );
}
function QuickToolBarCom(props: NavigationDropProps) {
    const allProps = { ...props }
    return (
        <Provider weId={`${props.weId || ''}_kh09tw`}    {...pcStores}>
            <QuickMenus weId={`${props.weId || ''}_c3ogp9`}      {...allProps} />
        </Provider>
    );
}
function FastCreateMenusCom(props: NavigationDropProps) {//快速新建组件
    return (
        <Provider weId={`${props.weId || ''}_tr4sbh`}   {...pcStores}>
            <FastCreateMenus weId={`${props.weId || ''}_cr8cwk`}     {...props} />
        </Provider>
    );
}
function CountTabCom(props: NavigationDropProps) {//待办事项、数量展示组件
    return (
        <Provider weId={`${props.weId || ''}_qr7hsi`}    {...pcStores}>
            <CountTab weId={`${props.weId || ''}_k4kx83`}      {...props} />
        </Provider>
    );
}
function HelpDropCom(props: NavigationDropProps) {//帮助展示组件
    return (
        <Provider weId={`${props.weId || ''}_dwnbhg`}    {...pcStores}>
            <HelpDrop weId={`${props.weId || ''}_mi4j1f`}      {...props} />
        </Provider>
    );
}
function MenuSettingDialogCom(props: NavigationDialogProps) {//菜单设置展示组件
    return (
        <Provider weId={`${props.weId || ''}_geh454`}     {...pcStores}>
            <MenuSettingDialog weId={`${props.weId || ''}_44l1tg`}        {...props} />
        </Provider>
    );
}
function TerminalDialogCom(props: NavigationDialogProps) {//企业微信及终端组件
    return (
        <Provider weId={`${props.weId || ''}_geh454`}     {...pcStores}>
            <TerminalDialog weId={`${props.weId || ''}_d1r15c`}        {...props} />
        </Provider>
    );
}
function TerminalCom(props: NavigationDialogProps) {//企业微信及终端组件DIalog内部
    return (
        <Provider weId={`${props.weId || ''}_geh454`}     {...pcStores}>
            <Terminal weId={`${props.weId || ''}_d1r15c`}        {...props} />
        </Provider>
    );
}
function InviteDialogCom(props: NavigationDialogProps) {//邀请加入团队组件
    return (
        <Provider weId={`${props.weId || ''}_geh454`}     {...pcStores}>
            <InviteDialog weId={`${props.weId || ''}_1zfz41`}       {...props} />
        </Provider>
    );
}
function TenantsDialogCom(props: NavigationDialogProps) { //创建团队
    return <Provider weId={`67vxds`} {...pcStores}>
        <TenantDialog weId={`${props.weId || ''}_ru3sen`}   {...props} />
    </Provider>
}
function InviteWelfareDialogCom(props: NavigationDialogProps) { //推荐拿福利弹窗
    return <Provider weId={`45eqwx`} {...pcStores}>
        <InviteWelfareDialog weId={`${props.weId || ''}_ru3sen`}   {...props} />
    </Provider>
}
function ClearCacheDialogCom(props: NavigationDialogProps) { //清除缓存
    return <Provider weId={`32dqeew`} {...pcStores}>
        <ClearCacheDialog weId={`${props.weId || ''}_qulmtg`}   {...props} />
    </Provider>
}
function AppDisplaySettingDialogCom(props: NavigationDialogProps) { //更多应用-设置
    return <Provider weId={`48gteqe`} {...pcStores}>
        <AppDisplaySetting weId={`${props.weId || ''}_dtuvjv`}   {...props} />
    </Provider>
}
function AppMainMenusCom(props: NavigationDialogProps) { //更多应用-设置
    return <Provider weId={`67vxds`} {...pcStores}>
        <AppMainMenus weId={`${props.weId || ''}_dtuvjv`}   {...props} />
    </Provider>
}
export { AccountInfoCom, AppDropMenusCom, TerminalCom, QuickSearchCom, TenantDropCom, QuickMenusCom, QuickToolBarCom, FastCreateMenusCom, CountTabCom, HelpDropCom, MenuSettingDialogCom, TerminalDialogCom, InviteDialogCom, TenantsDialogCom, ClearCacheDialogCom, WxchatCom, AppDisplaySettingDialogCom, AppMainMenusCom, InviteWelfareDialogCom }